export default __webpack_public_path__ + "static/media/playIcon.2012ecd3.svg";